module.exports = __webpack_public_path__ + "static/media/marble.db918472.jpg";